export function formatPrice(cents) {
    const n = typeof cents === 'bigint' ? Number(cents) : cents;
    return `$${(n / 100).toFixed(2)}`;
}
